var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedback = function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m2.278 7.066 8.25-4.95a.92.92 0 0 1 .944 0l8.25 4.95a.92.92 0 0 1 .445.786V19.25c0 .506-.41.917-.917.917H2.75a.917.917 0 0 1-.917-.917V7.852c0-.322.17-.62.445-.786m1.389 2.977v8.29h14.666v-8.29l-6.796 4.908a.92.92 0 0 1-1.074 0zm.446-1.94L11 13.079l6.887-4.974L11 3.97zm4.94.605a.917.917 0 0 1-.969-1.557l2.432-1.513a.92.92 0 0 1 .97.001l2.427 1.517a.917.917 0 0 1-.972 1.555l-1.024-.64V11a.917.917 0 0 1-1.834 0V8.066z",
    clipRule: "evenodd"
  })));
};
export default SvgFeedback;